import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = ["fill"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("mask", {
  id: "path-2-outside-1_3669_1571",
  maskUnits: "userSpaceOnUse",
  x: "5.41406",
  y: "6.20117",
  width: "15",
  height: "15",
  fill: "black"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    fill: "white",
    x: "5.41406",
    y: "6.20117",
    width: "15",
    height: "15"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M18.414 12.3262C18.4172 13.9272 17.8737 15.4812 16.8736 16.7314C15.9225 17.9202 14.6127 18.7665 13.1426 19.1462C12.9927 19.1849 12.8354 19.1849 12.6856 19.1462C11.2156 18.7665 9.90568 17.9202 8.95455 16.7314C7.95451 15.4812 7.41102 13.9272 7.41408 12.3262V9.57618C7.41408 9.21154 7.55899 8.86175 7.81687 8.60397C8.07465 8.34608 8.42444 8.20117 8.78909 8.20117H17.039C17.4038 8.20117 17.7535 8.34608 18.0114 8.60397C18.2692 8.86175 18.414 9.21154 18.414 9.57618V12.3262ZM16.2271 10.3431C16.5762 10.6052 16.6467 11.1007 16.3846 11.4498L13.3457 15.4967C13.0838 15.8456 12.5889 15.9163 12.2397 15.6547L10.2163 14.139C9.8669 13.8772 9.79587 13.3819 10.0575 13.0325C10.3193 12.683 10.8147 12.612 11.164 12.8737L12.5557 13.9162L15.1204 10.5005C15.3826 10.1515 15.8781 10.081 16.2271 10.3431Z"
  })
], -1)
const _hoisted_4 = ["fill"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M18.414 12.3262C18.4172 13.9272 17.8737 15.4812 16.8736 16.7314C15.9225 17.9202 14.6127 18.7665 13.1426 19.1462C12.9927 19.1849 12.8354 19.1849 12.6856 19.1462C11.2156 18.7665 9.90568 17.9202 8.95455 16.7314C7.95451 15.4812 7.41102 13.9272 7.41408 12.3262V9.57618C7.41408 9.21154 7.55899 8.86175 7.81687 8.60397C8.07465 8.34608 8.42444 8.20117 8.78909 8.20117H17.039C17.4038 8.20117 17.7535 8.34608 18.0114 8.60397C18.2692 8.86175 18.414 9.21154 18.414 9.57618V12.3262ZM16.2271 10.3431C16.5762 10.6052 16.6467 11.1007 16.3846 11.4498L13.3457 15.4967C13.0838 15.8456 12.5889 15.9163 12.2397 15.6547L10.2163 14.139C9.8669 13.8772 9.79587 13.3819 10.0575 13.0325C10.3193 12.683 10.8147 12.612 11.164 12.8737L12.5557 13.9162L15.1204 10.5005C15.3826 10.1515 15.8781 10.081 16.2271 10.3431Z",
  stroke: "white",
  "stroke-width": "2.5",
  mask: "url(#path-2-outside-1_3669_1571)"
}, null, -1)

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'recommendationIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#211F58",
  },
  width: {
    type: Number as PropType<number>,
    default: 20,
  },
  height: {
    type: Number as PropType<number>,
    default: 21,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.width,
    height: __props.height,
    viewBox: `0 0 ${__props.width} ${__props.height}`,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    class: "!tw-w-[19px] !tw-h-[19px]"
  }, [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1.66667 0H14.3333C14.5522 0 14.7689 0.0431096 14.9711 0.126867C15.1733 0.210625 15.3571 0.333391 15.5118 0.488155C15.6666 0.64292 15.7894 0.826652 15.8731 1.02886C15.9569 1.23107 16 1.4478 16 1.66667V14.3333C16 14.5522 15.9569 14.7689 15.8731 14.9711C15.7894 15.1733 15.6666 15.3571 15.5118 15.5118C15.3571 15.6666 15.1733 15.7894 14.9711 15.8731C14.7689 15.9569 14.5522 16 14.3333 16H1.66667C1.4478 16 1.23107 15.9569 1.02886 15.8731C0.826652 15.7894 0.64292 15.6666 0.488155 15.5118C0.333391 15.3571 0.210625 15.1733 0.126867 14.9711C0.0431096 14.7689 0 14.5522 0 14.3333V1.66667C0 1.22464 0.175595 0.800716 0.488155 0.488155C0.800716 0.175595 1.22464 0 1.66667 0Z",
      fill: __props.color
    }, null, 8, _hoisted_2),
    _hoisted_3,
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M18.414 12.3262C18.4172 13.9272 17.8737 15.4812 16.8736 16.7314C15.9225 17.9202 14.6127 18.7665 13.1426 19.1462C12.9927 19.1849 12.8354 19.1849 12.6856 19.1462C11.2156 18.7665 9.90568 17.9202 8.95455 16.7314C7.95451 15.4812 7.41102 13.9272 7.41408 12.3262V9.57618C7.41408 9.21154 7.55899 8.86175 7.81687 8.60397C8.07465 8.34608 8.42444 8.20117 8.78909 8.20117H17.039C17.4038 8.20117 17.7535 8.34608 18.0114 8.60397C18.2692 8.86175 18.414 9.21154 18.414 9.57618V12.3262ZM16.2271 10.3431C16.5762 10.6052 16.6467 11.1007 16.3846 11.4498L13.3457 15.4967C13.0838 15.8456 12.5889 15.9163 12.2397 15.6547L10.2163 14.139C9.8669 13.8772 9.79587 13.3819 10.0575 13.0325C10.3193 12.683 10.8147 12.612 11.164 12.8737L12.5557 13.9162L15.1204 10.5005C15.3826 10.1515 15.8781 10.081 16.2271 10.3431Z",
      fill: __props.color
    }, null, 8, _hoisted_4),
    _hoisted_5
  ], 8, _hoisted_1))
}
}

})